import React from "react";

import classes from "./Button.module.css";

export enum ButtonType {
  BUTTON = "button",
  SUBMIT = "submit",
  RESET = "reset",
}

type Props = {
  type?: ButtonType;
  children: React.ReactNode;
};

const Button = ({ type, children }: Props) => (
  <button className={classes.btn} type={type}>
    {children}
  </button>
);

export default Button;
